/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 // Date of Birth picker
jQuery.extend({
    dobPicker:  (params) =>  {

        // apply defaults
        if (typeof(params.dayDefault) == "undefined") {
            params.dayDefault = "Day";
        }
        if (typeof(params.monthDefault) == "undefined"){
            params.monthDefault = "Month";
        }
        if (typeof(params.yearDefault) == "undefined") {
            params.yearDefault = "Year";
        }
        if (typeof(params.minimumAge) == "undefined") {
            params.minimumAge = 18;
        }
        if (typeof(params.maximumAge) == "undefined") {
            params.maximumAge = 100;
        }

        // find elements
        var dayElement = $(params.daySelector);
        var monthElement = $(params.monthSelector);
        var yearElement = $(params.yearSelector);

        // set days
        dayElement.append("<option value=\"\">" + params.dayDefault + "</option>");
        for (var i = 1; i <= 31; i++) {
            var day = "" + i;
            var value = i > 9 ? "" + i : "0" + i;
            dayElement.append("<option value=\"" + value + "\">" + day + "</option>");
        }
      

        // set months
        var months = [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12"
        ];
        monthElement.append("<option value=\"\">" + params.monthDefault + "</option>");
        for (var i = 1; i <= 12; i++) {
            var month = months[i - 1];
            var value = i > 9 ? "" + i : "0" + i;
            monthElement.append("<option value=\"" + value + "\">" + month + "</option>");
        }

        // set years
        var now = (new Date()).getFullYear();
        var minimum = now - params.minimumAge;
        var maximum = minimum - params.maximumAge;
        yearElement.append("<option value=\"\">" + params.yearDefault + "</option>");
        for (i = minimum; i >= maximum; i--) {
            var year = "" + i;
            var value = year;
            yearElement.append("<option value=\"" + value + "\">" + year + "</option>");
        }

        // disable months
        dayElement.change(function () {

            monthElement.selectedIndex = 0;
            yearElement.selectedIndex = 0;
            yearElement.find("option").removeAttr("disabled");

            var day = parseInt(dayElement.val());

            if (day >= 1 && day <= 29) {
                monthElement.find("option").removeAttr("disabled");
            } else if (day == 30) {
                monthElement.find("option").removeAttr("disabled");
                monthElement.find("option[value=\"02\"]").attr("disabled", "disabled");
            } else if(day == 31) {
                monthElement.find("option").removeAttr("disabled");
                monthElement.find("option[value=\"02\"]").attr("disabled", "disabled");
                monthElement.find("option[value=\"04\"]").attr("disabled", "disabled");
                monthElement.find("option[value=\"06\"]").attr("disabled", "disabled");
                monthElement.find("option[value=\"09\"]").attr("disabled", "disabled");
                monthElement.find("option[value=\"11\"]").attr("disabled", "disabled");
            }

        });

        // disable years
        monthElement.change(function () {

            yearElement.selectedIndex = 0;
            yearElement.find("option").removeAttr("disabled");

            var day = parseInt(dayElement.val());
            var month = parseInt(monthElement.val());

            if (day == 29 && month == 2) {
                yearElement.find("option").each(function (index, value) {
                    if (index > 0) {
                        var option = $(value);
                        var year = parseInt(option.attr("value"));
                        if (year % 4 == 0) {
                            option.attr("disabled", "disabled");
                        }
                    }
                });
            }

        });

    }

});


//商品一覧のサイドバー
$(function () {
  $(".CollectionMenu__List--Link span.plus").on({
    click: function () {
      $(this).toggleClass("active");
      $(this)
        .parent("div")
        .next("ul")
        .slideToggle(400);
      return false;
    },
  });
});

//外部のページを新しいタブで開く
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}
//商品詳細 -ギフト発送について 開閉ボタン
$(function(){
  $(".productMetafieldTab_title").on("click", function() {
    $(this).next().slideToggle();
    $(this).toggleClass("active");
  });
});


//マイページ(サブスクページ)
window.addEventListener('DOMContentLoaded', ()=>{
  if(location.search === "?hbSubscriptionPath=/" || location.search === "?hbSubscriptionPath=%2F"){
    const elements = document.getElementsByClassName('PageLayout__Section');
    for( let i = 0 ; i < elements.length ; i ++ ) {
       if(elements[i].classList.contains("subscription__Section") == true ){
         continue;
       }
       elements[i].style.display =  'none';
    }
  }
});